var isVideoBlocked = function isVideoBlocked(manifest) {
  var _manifest$main;

  return !!(manifest !== null && manifest !== void 0 && manifest.status && manifest.meta && !((_manifest$main = manifest.main) !== null && _manifest$main !== void 0 && _manifest$main.length));
};

export default isVideoBlocked;